<template>
  <div>
    <div class="mt-2">
      •&nbsp;&nbsp;Users need to make a first deposit to use this function. If
      you are a new customer please
      <el-link
        :href="routeUrl.RECHARGE"
        class="ml-1 mr-1"
        :underline="false"
        type="primary"
        target="_blank"
        style="font-size: 0.8rem; margin-bottom: 0.1rem"
        >Recharge now</el-link
      >
      to continue
    </div>
  </div>
</template>

<script>
// Extend
import base from "@/scripts/base";

export default {
  extends: base,
};
</script>